module.exports = __webpack_public_path__ + "img/search.8c5bc9f4.svg";